import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EngagementCategoryContainerModel } from '../../../../../../models/aggregates/erp/engagement';
import { BaseApiTemplateService, Core2Config } from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class EngagementCategoryService extends BaseApiTemplateService<EngagementCategoryContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.ENGAGEMENT_PREFIX + 'categories/backoffice-ep';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.ENGAGEMENT_PREFIX + 'categories/backoffice-ep'; 
    this.httpClient = http;
  }
}
